import { useEffect, useState } from "react";
import usePermissionsRequest from "./usePermissionsRequest";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAccessToken } from "../../features/auth/authSlice";
import useApiRequest from "../../helpers/api_request";
import { Link, useNavigate } from "react-router-dom";
import useErrorToast from "../../helpers/errorToast";
import { showToastMessage } from "../../features/generalSlice";
import { BASE_URL } from "../../helpers/constants";
import { toast } from "react-toastify";
import AppButton from "../elements/AppButton";

export default function CreateRole() {
    const { fetchingPermissions, permissions, getPermissions } = usePermissionsRequest()
    useEffect(() => {
        getPermissions()
    }, [])

    const [name, setName] = useState("");
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([])
    const [saving, setSaving] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const dispatch = useAppDispatch()
    const apiRequest = useApiRequest()
    const navigate = useNavigate();

    const errorToast = useErrorToast()
    const saveRole = async () => {
        if (name === '') {
            dispatch(showToastMessage({
                message: "Name is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return;
        }
        setSaving(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/role/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                name: name,
                permissions: selectedPermissions
            }
        }).then((response) => {
            setSaving(false)
            dispatch(showToastMessage({
                message: "Role Created ",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            navigate("/admins")
        }).catch((error) => {
            errorToast(error);
            setSaving(false)
        });
    }
    const togglePermissions = (permission: string) => {
        setSelectedPermissions((prevPermissions) => {
            const index = prevPermissions.indexOf(permission);
            if (index === -1) {
                // Permission does not exist, so add it to the array
                return [...prevPermissions, permission];
            } else {
                // Permission already exists, so remove it from the array
                const updatedPermissions = [...prevPermissions];
                updatedPermissions.splice(index, 1);
                return updatedPermissions;
            }
        });
    };



    return (
        <div>
            <div className="card">
                <div className="card-body pt-4 pb-4">
                    <div className="flex">
                        <nav className="flex justify-between" aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <Link to={"/admins"}>
                                    <div className="flex items-center">
                                        <h5 className="card-title">Admins</h5>
                                    </div>
                                </Link>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                        <h5 className="card-title">Create</h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className=" mt-4">

                        <div className="w-1/2 mt-4">
                            <label htmlFor="lastName" className="form-label-1 ">Role Name</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="" className="form-input-2" />
                        </div>

                        <div className="mt-4">
                            <label htmlFor="lastName" className="form-label-1 ">Permissions</label>
                            <div className=" grid grid-cols-4">
                                {permissions.map((item, key) =>
                                    <div key={key} className="flex items-center mt-3">
                                        <input onChange={() => togglePermissions(item)} id={item} type="checkbox" value="" className="w-3.5 h-3.5 text-blue-600 bg-gray-100 rounded-full focus:ring-blue-500 " />
                                        <label htmlFor={item} className="ml-2 text-sm font-medium text-gray-600 ">{item} </label>
                                    </div>
                                )
                                }
                            </div>
                        </div>

                        <div className=" mt-5">
                            <AppButton callBackFun={() => saveRole()} showLoader={saving} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2" text="Save" />
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}




